export { ISignInProps } from './exported/sign-in-form/SignInForm';
export { AUTHENTICATION_SOURCES } from './internal/constants/constants';
export { SignInFormService } from './service-setup/SignInFormService';
import { diContainer, serviceNames } from './service-setup/diContainer';
import { setupServiceInfo } from 'elc-universal-utils';

diContainer.get(serviceNames.signInFormService).register();

setupServiceInfo(__serviceInfo__);
